export { default } from './FormGeneratorRichTextEditor';
